// extracted by mini-css-extract-plugin
module.exports = {"goto":"GotoImage_goto__3_NLa"};